import React from "react";
import styled from "styled-components";

import fb from "./images/socials/fb.svg";
import insta from './images/socials/insta.svg';
import twitter from './images/socials/twitter.svg';
import tiktok from './images/socials/tiktok.svg';
import email from './images/socials/email.svg';

import { colors } from "../shared/config";

const Container = styled.div`
	background-color: ${colors.background};
	height: auto;
	color: white;
	padding: 60px 0 10px 0;
    text-align: center;
	h1 {
		margin: 0;
		font-size: 25px;
    font-family: ITC Century;
	}
  /* margin-bottom: 20px; */
`

const Socials = styled.div`
    position: relative;
	margin-top: 20px;
  
	img {
    position: relative;
		margin: 0 20px;
	}
	p {
    position: relative;
		margin: 80px 20px;
    background-color: ${colors.background};
    font-family: Optima;
	}
`

const Footer = () => {
    return (
        <Container>
        <h1>DAILY BRUIN</h1>
        <Socials>
          <a href="https://www.instagram.com/dailybruin" target="_blank"><img src={insta}/></a>
          <a href="https://www.facebook.com/dailybruin" target="_blank"><img src={fb}/></a>
          <a href="https://www.twitter.com/dailybruin" target="_blank"><img src={twitter}/></a>
          <a href="https://www.tiktok.com/@dailybruin" target="_blank"><img src={tiktok}/></a>
          <a href="http://eepurl.com/cFEiZX" target="_blank"><img src={email}/></a>
          <p>Built with Suzy’s ♥ in Kerckhoff 118 by Mattie Sanseverino, Lindsey Parungo, Laurel Woods, Sid Baphna, Sunny Li and Angad Kapoor. Designed by Lauren Ho.</p>
        </Socials>
    </Container>
    )
  }
  
export default Footer;